// Frontend-side session token management. Stored in localStorage so it
// survives across requests on browsers that block 3rd-party cookies (iOS
// Safari is the big one). Sent via Authorization: Bearer header.

const KEY = 'marsad-session-token';

export function saveToken(token: string): void {
  try { localStorage.setItem(KEY, token); } catch { /* private mode etc. */ }
}

export function getToken(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function clearToken(): void {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

// Helper: build fetch headers with Authorization if a token exists.
export function authHeaders(extra?: Record<string, string>): Record<string, string> {
  const h: Record<string, string> = { ...(extra ?? {}) };
  const t = getToken();
  if (t) h.Authorization = `Bearer ${t}`;
  return h;
}
